import * as d3 from 'd3'

export default {
  methods: {

    refresh_Chart() {
      
      // Setting Primary
      let tData = this.trendData.filter(f=> f[this.ref.item]==this.current)
      this.primary.max = this.gmx_maxBound5(d3.max(tData, c => c[this.ref.trend]))

      this.primary.axis = d3.scaleLinear()
      .domain([0, this.primary.max])
      .range([0, this.trend.height])

      this.trend.average = d3.mean(tData, c => c[this.ref.trend])

      this.refreshing()
    },

    refreshing() {

      // Average
      this.gmx_textTween(`#AVG_VALUE_${this.localId}`, this.trend.average, 300)

      d3.select(`#AVG_LINE_${this.localId}`).transition().duration(300)
      .attr('y1', this.trend.height-this.primary.axis(this.trend.average))
      .attr('y2', this.trend.height-this.primary.axis(this.trend.average))

      // Grid
      for(let i=0; i<6; i++) {
        this.gmx_textTween(`#GRID_${i}_${this.localId}`, (this.primary.max * (i*.2)).toFixed(0), 300)
      }

      // Trend Chart
      this.timeline.xItems.forEach((d,i)=> { 
        
        let data = this.trendData.find(f=> f[this.ref.item] == this.current && f[this.ref.timeline] == d.name)
        let value = data[this.ref.trend]

        d3.select(`#BAR_${i}_${this.localId}`).transition().duration(300)
        .attr('y', this.trend.height-this.primary.axis(value))
        .attr('height', this.primary.axis(value))

        this.gmx_textTween(`#VALUE_${i}_${this.localId}`, value, 300, null, null, this.trend.height-this.primary.axis(value)-6, value==0 ? '#E0E0DF' : '#757575')
      })
      
      // Week Perfprmance
      let weekData = this.weekData.filter(f=> f[this.ref.item]==this.current)
      weekData.forEach((d,i)=> {
        this.gmx_textTween(`#WEEK_${i}_${this.localId}`, d[this.ref.week], 300, null, null, null, d[this.ref.week]==0 ? '#E0E0DF' :'#333')
      })
    }

  }
}